import React from "react";
import { reportClientError } from "@/lib/reportError";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught:", error, info);
    reportClientError("boundary:" + (this.props.name || "app"), error, info?.componentStack);
  }

  componentDidUpdate(prev) {
    if (this.state.hasError && prev.resetKey !== this.props.resetKey) this.setState({ hasError: false });
  }

  render() {
    if (this.state.hasError) {
      if (this.props.silent) return this.props.fallback ?? null;
      return (
        <div className="min-h-[70vh] flex flex-col items-center justify-center bg-[#0A0F0B] px-6 text-center" data-testid="error-boundary">
          <div className="font-mono text-xs tracking-widest text-[#2A7D4A]">SOMETHING WENT WRONG</div>
          <h1 className="mt-3 font-display text-5xl font-black text-[#F4F6F0]" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
            THIS PAGE HIT A SNAG
          </h1>
          <p className="mt-3 max-w-md text-[#6B7C6E]">
            Sorry about that. You can head back home or keep browsing the shop — your cart is safe.
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <a href="/" className="rounded-xl bg-[#1B5E35] px-7 py-3.5 font-bold text-[#F4F6F0] transition-colors hover:bg-[#2A7D4A]" data-testid="error-home-btn">Return Home</a>
            <a href="/shop" className="rounded-xl border border-[#1B5E35]/40 px-7 py-3.5 font-bold text-[#F4F6F0] transition-colors hover:border-[#1B5E35]">Browse Shop</a>
            <button onClick={() => window.location.reload()} className="rounded-xl border border-[#1B5E35]/40 px-7 py-3.5 font-bold text-[#F4F6F0] transition-colors hover:border-[#1B5E35]">Try Again</button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
